import { render, staticRenderFns } from "./btsb-c.vue?vue&type=template&id=7c25e5d9&scoped=true"
import script from "./btsb-c.vue?vue&type=script&lang=js"
export * from "./btsb-c.vue?vue&type=script&lang=js"
import style0 from "./btsb-c.vue?vue&type=style&index=0&id=7c25e5d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c25e5d9",
  null
  
)

export default component.exports